import { combineReducers } from 'redux';

import containerReducer from './container';
import filtersReducer from './filters';

const reducers = {
  container: containerReducer,
  filters: filtersReducer,
};

export default combineReducers(reducers);
